import { ContentType } from 'hooks/queries/schedules/useAddToBrandPlanSchedule'
import { DesignChannel } from 'components/NewFileModal/Types'
import {
  isBlogChannel,
  isBlogOrEmailChannel,
  isEmailChannel,
  isSocialChannel,
  isVideoChannel,
} from 'screens/Calendar/FullScreenPreview/utils'
import { Additionals } from 'screens/Calendar/WeekViewV2/BatchContentActions/Modals/AddMoreContentModal/Types'

export const calculateCreditCounts = (
  channelCounts: Record<ContentType, number> | undefined,
  additionals: Additionals | undefined,
) => {
  let counts = { social: 0, blogAndEmail: 0, blog: 0, email: 0, shortFormVideo: 0 }
  if (additionals) {
    Object.keys(additionals).forEach((key) => {
      if (key === 'crosspost_post') {
        counts.social += additionals[key]
      }
      if (isSocialChannel(key)) {
        counts.social += additionals[key]
      }
      if (isBlogOrEmailChannel(key)) {
        counts.blogAndEmail += additionals[key]
      }
      if (isBlogChannel(key)) {
        counts.blog += additionals[key]
      }
      if (isEmailChannel(key)) {
        counts.email += additionals[key]
      }
      if (isVideoChannel(key as DesignChannel)) {
        counts.shortFormVideo += additionals[key]
      }
    })
  }

  if (channelCounts) {
    Object.keys(channelCounts || {}).forEach((key) => {
      if (isSocialChannel(key)) {
        counts.social += channelCounts[key as ContentType]
      }
      if (isBlogOrEmailChannel(key)) {
        counts.blogAndEmail += channelCounts[key as ContentType]
      }
      if (isBlogChannel(key)) {
        counts.blog += channelCounts[key as ContentType]
      }
      if (isEmailChannel(key)) {
        counts.email += channelCounts[key as ContentType]
      }
      if (isVideoChannel(key as DesignChannel)) {
        counts.shortFormVideo += channelCounts[key as ContentType]
      }
    })
  }

  return counts
}
